module.exports = __webpack_public_path__ + "assets/cover_2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_2.jpg
 ** module id = 110
 ** module chunks = 1
 **/